import { useOutletContext } from "react-router-dom";
import { WebActivityInfoCtx } from "../../webInterface";


const WebActivityInfo: React.FC = () => {

    const { activity } = useOutletContext() as WebActivityInfoCtx

    return (
        <>
            <div>
                <p>Info page for {activity.name}</p>
                <p>{activity.description}</p>
            </div>
        </>
    )
}

export default WebActivityInfo;